<template>
  <div class="page pageAsOverlay" style="background: none">

    <div class="spacer-20"></div>

    <v-container grid-list-xl>

      <div class="superCenter">
        <div class="rating-feedback bgw myBorderRadius">
          <div class="absClose" @click.passive.stop="close">
            <v-icon bigger class="myBlack"
            >mdi-close
            </v-icon>
          </div>

          <div v-if="pageMode==='input'" class="rating-feedback">
            <h2 class="mb-2">Bewerten Sie Ihren Besuch</h2>
            <div class="mb-7">Nach der Bewertung wird dein Bezahlwunsch direkt gesendet</div>
            <form @submit.prevent="submitFeedback">
              <div class="rating-group" v-for="(rating, index) in ratings" :key="index">
                <label :for="rating.key">{{ rating.label }}</label>
                <div class="stars">
          <span
            v-for="star in 5"
            :key="star"
            class="star"
            :class="{ filled: rating.value >= star }"
            @click="setRating(index, star)"
          >&#9733;</span>
                </div>
              </div>
              <v-btn block class="btn-df rounded100 greenBtn"
                     :class="{orderPulsing: finishedInput}"
                     @click="clickSubmit"
              >
                <!--            <v-icon left medium>-->
                <!--              mdi-cart-arrow-down-->
                <!--            </v-icon>-->
                <span>Feedback absenden</span>
              </v-btn>
              <!--          <button type="submit" class="submit-button">Feedback absenden</button>-->
            </form>
          </div>

          <div v-if="pageMode==='confirmed'" class="text-center">
            <div class="pa-9">
              <div class="icon icon--order-success svg">
                <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
                  <circle stroke="#50A92F" stroke-width="2" cx="36" cy="36" r="34" fill="none"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" fill="#50A92F"
                        d="M52.5 21.4c-.9-.6-2.1-.5-2.8.2l-20.7 20.2-4.7-5.1c-.8-.8-2.4-1.2-3.5-.5-1.1.9-1.2 2.3-.5 3.5 0 0 5.1 8.7 5.7 9.7s1.6 1.6 3 1.6c1.1 0 2-.6 2.9-1.6.7-.8 20.8-25.3 20.8-25.3.6-.7.6-2-.2-2.7z"></path>
                </svg>
              </div>
              <div class="pt-7">
                <h2>Vielen Dank für dein Feedback</h2>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!--        <v-btn class="btn-df" @click="clickFinal">-->
      <!--          Weiter-->
      <!--        </v-btn>-->
      <!--      </div>-->

    </v-container>
  </div>
</template>

<script>
import {ebus} from "@/vendor/ebus";
import store from "@/store/store";
import * as qconst from "@/vendor/qconstants";
import * as util from "@/vendor/util";
import * as xhr from "@/api/xhr";
import {cloneMe, generateClientId} from "@/vendor/util";

export default {
  name: "RatingFeedback",
  data() {
    return {
      pageMode: 'input',
      ratings: [
        {key: 'friendliness', label: 'Freundlichkeit des Personal', value: 0},
        {key: 'quality', label: 'Qualität der Speisen', value: 0},
        {key: 'selection', label: 'Auswahl der Speisen', value: 0},
        {key: 'cleanliness', label: 'Sauberkeit des Restaurants', value: 0},
      ],
    };
  },
  computed: {
    finishedInput() {
      let atLeastOneStar = true;
      for (let r of this.ratings) {
        if (r.value < 1) {
          atLeastOneStar = false;
          break;
        }
      }
      return atLeastOneStar;
    }
  },
  methods: {
    close() {
      this.$store.commit('selectedDialog', '');
      this.$store.commit('showDialogContainer', false);
    },
    // clickFinal(){
    //   window.history.back();
    //   // store.commit('selectedDialog', '');
    //   // store.commit('showDialogContainer', false);
    // },
    clickSubmit() {
      if (!this.finishedInput) {
        ebus.$emit('showInfo', {
          title: 'Bitte jede Kategorie bewerten mit mindestens einem Stern',
          // text: 'Vielen Dank!'
        });
        return;
      }

      this.pageMode = 'confirmed';

      let doc = {
        ratings: cloneMe(this.ratings),
        createdAt: Date.now(),
        table: store.getters.table,
      }

      let msg = {
        action: qconst.action$DocUpserter,
        collectionName: 'ratingFeedback',
        updates: doc,
        // prefix: 'shop_',
        subjectKey: {
          key: 'ratingId',
          value: generateClientId(),
        },
        autoRetry: false,
      };
      xhr.xhrSend(true, msg, (reply) => {
        if (reply && reply.ok) {
          setTimeout(() => {
            ebus.$emit('finishedRating');
          }, 2000);
        } else {
          ebus.$emit('error', 'Fehler bei der Speicherung');
        }
      }, (err) => {
        ebus.$emit('error', 'Fehler mit der Netzwerkverbindung');
      });
    },
    setRating(index, value) {
      this.ratings[index].value = value;
    },
  },
}

</script>

<style scoped lang="scss">
@import '@/styles/base.scss';

.myBorderRadius {
  border: 1px solid $color-primary;
  background-color: $color-secondary;
}

.rating-feedback {
  position: relative;
  max-width: 600px;
  //margin: 0 auto;
  padding: 16px 20px;
}

.rating-group {
  margin-bottom: 20px;
}

label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

.stars {
  display: flex;
}

.star {
  font-size: 30px;
  cursor: pointer;
  color: #ccc;
  transition: color 0.3s;
}

.star.filled {
  color: #f5a623;
}


//////////////////////////
.icon--order-success svg path {
  -webkit-animation: checkmark 0.25s ease-in-out 0.7s backwards;
  animation: checkmark 0.25s ease-in-out 0.7s backwards
}

.icon--order-success svg circle {
  -webkit-animation: checkmark-circle 0.6s ease-in-out backwards;
  animation: checkmark-circle 0.6s ease-in-out backwards
}

//////////////////////////

</style>
